import { IncomingMessage } from "http";
import { parse } from "url";

/**
 * Sets the asos-shop header from the sc_site query parameter if present and asos-shop header is not already set
 * @param req - The incoming request object
 */
export const setAuthoringShopHeaders = (req: IncomingMessage): void => {
  // If asos-shop header is already present, don't override it
  if (req.headers["asos-shop"]) {
    return;
  }

  // Parse sc_site from querystring and set asos-shop header if present
  const url = req.url || "";
  const { query } = parse(url, true);

  if (query.sc_site && typeof query.sc_site === "string") {
    const sitecoreSite = query.sc_site.toLowerCase();
    console.log(
      `Setting asos-shop header to ${sitecoreSite} based on query parameter sc_site`,
    );
    req.headers["asos-shop"] = sitecoreSite;
  }
};
